import React from 'react';
import locationIcon from  '../../../../assets/images/clientInterviewLlocation.svg';
import interviewTypeIcon from'../../../../assets/images/clientInterviewType.svg';
import './InterviewDetails.css';
import Icon from '../../../UI/Icon/Icon';


const InterviewDetails = (props) => {
  return(
    <div className="interview-details desktop-padding">
      <h4>Interview details</h4>
      <ul>
        <li>
          <Icon icon="candidate-interview-map"/>
          <div className="candidate-interview-map-location">
            <h6>Location</h6>
            <p>{props.interviewLocation?props.interviewLocation:""}</p>
          </div>
        </li>
        <li>
          <Icon icon="interview-type-icon"/>
          <div>
            <h6>Interview Type</h6>
            <p>{props.interviewType?props.interviewType:""}</p>
          </div>
        </li>
      </ul>
    </div>
  );
}

export default InterviewDetails;


// WEBPACK FOOTER //
// ./src/components/Client/ClientInterviewSchedular/InterviewDetails/InterviewDetails.js